export default "__VITE_ASSET__6UwtsGtw__"